export const mapUiStatusToStatusLabelStyle = (uiStatus: string) => {
  if (uiStatus === "Banner Applied") {
    return "info";
  }
  if (
    ["Action Needed", "Rejected", "Undeliverable", "Deferred"].includes(
      uiStatus,
    )
  ) {
    return "danger";
  }
  return "success";
};
